/**
 * Messaging Campaign enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports (safe for frontend use)
 */
// Campaign type / preset
export const campaignTypeLabels = {
    intro_offer: 'Intro Offer',
    gmb_review: 'Google Review Request',
    custom: 'Custom',
};
export const campaignTypeValues = Object.keys(campaignTypeLabels);
// Campaign lifecycle status
export const campaignStatusLabels = {
    draft: 'Draft',
    scheduled: 'Scheduled',
    sending: 'Sending',
    paused: 'Paused',
    sent: 'Sent',
    failed: 'Failed',
    cancelled: 'Cancelled',
};
export const campaignStatusValues = Object.keys(campaignStatusLabels);
// Channels a campaign can send through
export const campaignChannelLabels = {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WhatsApp',
};
export const campaignChannelValues = Object.keys(campaignChannelLabels);
// Per-recipient send status
export const campaignRecipientStatusLabels = {
    queued: 'Queued',
    sending: 'Sending',
    sent: 'Sent',
    delivered: 'Delivered',
    failed: 'Failed',
    bounced: 'Bounced',
    opted_out: 'Opted Out',
    skipped: 'Skipped',
};
export const campaignRecipientStatusValues = Object.keys(campaignRecipientStatusLabels);
// Append-only tracking event types
export const campaignEventTypeLabels = {
    sent: 'Sent',
    delivered: 'Delivered',
    open: 'Opened',
    click: 'Clicked',
    unsubscribe: 'Unsubscribed',
    // A recipient marked the email as spam (Resend `email.complained`).
    complaint: 'Marked as spam',
    conversion: 'Converted',
    paused: 'Paused',
    resumed: 'Resumed',
};
export const campaignEventTypeValues = Object.keys(campaignEventTypeLabels);
// Why a contact was suppressed (org-level opt-out list)
export const suppressionReasonLabels = {
    unsubscribe: 'Unsubscribed',
    stop: 'Replied STOP',
    bounce: 'Hard Bounce',
    complaint: 'Spam Complaint',
};
export const suppressionReasonValues = Object.keys(suppressionReasonLabels);
// WhatsApp template approval lifecycle (mirrors Meta status)
export const whatsappTemplateStatusLabels = {
    pending: 'Pending Review',
    approved: 'Approved',
    rejected: 'Rejected',
    paused: 'Paused',
    disabled: 'Disabled',
};
export const whatsappTemplateStatusValues = Object.keys(whatsappTemplateStatusLabels);
// Per-org Twilio number provisioning status
export const smsNumberStatusLabels = {
    provisioning: 'Provisioning',
    active: 'Active',
    failed: 'Failed',
    released: 'Released',
};
export const smsNumberStatusValues = Object.keys(smsNumberStatusLabels);
/** Contact opt-outs also cover conversation-only channels. Campaign sends
 * retain the narrower campaignChannelValues set. */
export const suppressionChannelLabels = {
    email: 'Email',
    sms: 'SMS',
    whatsapp: 'WhatsApp',
    facebook_messenger: 'Messenger',
    instagram_dm: 'Instagram',
};
export const suppressionChannelValues = Object.keys(suppressionChannelLabels);
//# sourceMappingURL=campaigns.js.map